export enum ECommunicationMethod {
  PHONE = 'Звонок по телефону',
  EMAIL = 'Электронная почта',
}
